import { Box, Chip } from "@mui/material";
import styled from "@emotion/styled";

export const UserInfoContainer = styled(Box)`
  padding: 8px 16px;
  marginbottom: 10px;
`;

export const IconContainer = styled(Box)`
  display: flex;
  justify-content: center;
`;

interface DropdownContainerProps {
  open: boolean;
}
export const DropdownContainer = styled(Chip)<DropdownContainerProps>`
  gap: 12px;
  padding: 8px;
  background: white;
  height: 40px;
  border-radius: 154.76px;
  border-width: ${({ open }) => (open ? "1.5px" : "0px")};
  border-style: solid;
`;
